const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const URLMake = require("../../../shared/URLMake");
const ErrorUtil = require("../../../shared/ErrorUtil");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Slots = require("../../core/vault/Slots");
const {atParentAccount} = require("../../core/vault/StateCursors");
const OpsParentAcc = require("../vault/OpsParentAcc");
const LoadGuard = require("../../core/view/LoadGuard");
const GotProblems = require("../../core/top/GotProblems");
const InitRenderSwitch = require("../../core/view/InitRenderSwitch");
const LoadingCircle = require("../../core/view/LoadingCircle");
const Link = require("../../core/view/Link");
const AT = require("../../core/vault/ActionTypes");
const {PortalDestination} = require("../../core/view/PortalDestination");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const ChooseSubscription = require("./ChooseSubscription");
const SubscriptionBilling = require("./SubscriptionBilling");
const SubscriptionShipping = require("./SubscriptionShipping");
const ReviewSubscription = require("./ReviewSubscription");
const ConfirmSubscription = require("./ConfirmSubscription");
const CheckoutSteps = require("../../office/CheckoutSteps");
const CopyTable = require("../../office/data/CopyTable");
const GeneralCopy = require("../../core/util/CopyTable");
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const Cookie = require("../../core/util/Cookie");

const styles = require("./styles/PageSubscribe.css");

const sectionEls = {
	subscribe: ChooseSubscription,
	billing: SubscriptionBilling,
	shipping: SubscriptionShipping,
	review: ReviewSubscription,
	confirm: ConfirmSubscription,
};
const checkoutErrorCopy = CopyTable.getCheckoutErrorCopy();

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		account: atParentAccount(vaultState).get(),
		parentData: Slots.getValue(vaultState, Slots.table.parentData()),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageSubscribe",

		propTypes: {
			changeType: PT.oneOf(["add", "renew", "switch", "reactivate", "upgrade"])
				.isRequired,
			studentID: PT.number,
			step: PT.string,
			setNextScrollTo: PT.func.isRequired,

			// Injected by HOCs
			account: PT.object.isRequired,
			parentData: PT.object,
			dispatch: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {step: "subscribe"};
		},

		getInitialState: function() {
			return {
				topErrorText: "",
			};
		},

		// Used by vault update HOC
		vaultEvents: {
			checkoutFieldsError: function(step, fields) {
				this.showError("shippingFieldError");
			},
			parentVerifyAddressSuccess: function() {
				if (this.props.step === "shipping") {
					this.clearError();
					this.nextSection();
				}
			},
			parentVerifyAddressFail: function(step, fields) {
				this.showError("shippingFieldError");
			},
			parentNewDefaultShippingSuccess: function() {
				if (this.props.step === "shipping") {
					this.clearError();
					this.nextSection();
				}
			},
			parentNewDefaultShippingFail: function(step, fields) {
				this.showError("shippingFieldError");
			},
		},

		componentDidUpdate: function(prevProps) {
			if (this.props.step !== prevProps.step) {
				this.props.setNextScrollTo("top");
			}
		},

		loadParentAccount: function() {
			this.props.dispatch({
				type: AT.LOAD_PARENT_ACCOUNT_REQUEST,
			});
		},

		clearError: function() {
			this.setState({topErrorText: ""});
		},

		showError: function(errorType) {
			const errorText =
				checkoutErrorCopy[errorType] || checkoutErrorCopy.default;
			this.setState({topErrorText: errorText});
		},

		setSection: function(newSection) {
			if (newSection !== this.props.step) {
				this.props.dispatch({
					type: AT.SET_PAGE,
					pageState: URLMake.state.forAccountSubscribe(
						this.props.changeType,
						this.props.studentID,
						newSection
					),
					addToHistory: true,
				});
			}
		},

		nextSection: function() {
			const {account, step} = this.props;
			const steps = OpsParentSubChange.getAllSteps(account).concat(["confirm"]);
			const currIndex = steps.indexOf(step);
			if (currIndex < 3 && currIndex > -1) {
				this.setSection(steps[currIndex + 1]);
			}
		},

		renderSteps: function() {
			const {account, step} = this.props;
			const steps = OpsParentSubChange.getAllSteps(account);
			const availableSteps = OpsParentSubChange.getAvailableSteps(account);
			return (
				<CheckoutSteps
					steps={steps}
					stepLabels={steps}
					availableSteps={availableSteps}
					currentStep={step}
					onChangeStep={this.setSection}
					smallerMargin={true}
				/>
			);
		},

		renderError: function(error) {
			const linkOrButton = (
				<Link className={styles.goBack} to={URLMake.forAccount()}>
					{"Back to Account"}
				</Link>
			);
			const message =
				checkoutErrorCopy[error] || GeneralCopy.standardErrorMessages["404"];
			return <GotProblems message={message} linkOrButton={linkOrButton} />;
		},

		getSubscribeTitle: function(studentName) {
			const {changeType} = this.props;
			const titles = {
				reactivate: `Reactivate Subscription for ${studentName}`,
				renew: `Renew Subscription for ${studentName}`,
				switch: `Change Subscription for ${studentName}`,
				add: studentName
					? `Add a New Subscription for ${studentName}`
					: "Add A New Student",
				upgrade: `Upgrade Subscription for ${studentName}`,
			};
			return titles[changeType];
		},

		isStudentInActiveClassesBlocked: function() {
			const {account, changeType, parentData, studentID} = this.props;
			if (
				account.subChangeState &&
				account.subChangeState.error === "studentInActiveClasses"
			) {
				return true;
			}
			return (
				!!studentID &&
				changeType === "reactivate" &&
				OpsParentAcc.isStudentInActiveClasses(account, studentID, parentData)
			);
		},

		renderStudentInActiveClassesNotice: function() {
			const {account, studentID, parentData} = this.props;
			const studentName =
				OpsParentAcc.getStudentDisplayName(account, studentID, parentData) ||
				OpsParentSubChange.getDisplayName(account) ||
				"your student";
			const accessEndsAt = OpsParentAcc.getStudentAccessEndsAt(
				account,
				studentID
			);
			return (
				<div className={styles.main}>
					<div className={styles.title}>
						{this.getSubscribeTitle(studentName)}
					</div>
					<div className={styles.mainContent}>
						<div className={styles.classEnrollmentNotice}>
							{CopyTable.getStudentInActiveClassesMessage(
								studentName,
								styles,
								accessEndsAt
							)}
						</div>
						<Link className={styles.goBack} to={URLMake.forAccount()}>
							{"Back to Account"}
						</Link>
					</div>
				</div>
			);
		},

		renderLoaded: function() {
			const {account, changeType, step} = this.props;

			if (!account.subChangeState) {
				ErrorUtil.log(
					"E_BAD_STATE",
					"Got to change subscription flow with " +
						"account loaded and without account.subChangeState set. " +
						"syncSubChangeToPage hook in UpdateParentAcc is malfunctioning."
				);
				return this.renderError("Failed to initialize state");
			} else if (this.isStudentInActiveClassesBlocked()) {
				return this.renderStudentInActiveClassesNotice();
			} else if (account.subChangeState.error) {
				return this.renderError(account.subChangeState.error);
			}

			const studentName = OpsParentSubChange.getDisplayName(account) || "";
			const classWalletCookie = Cookie.get("cw");
			const MainType = sectionEls[step];
			const content = (
				<MainType
					account={this.props.account}
					setSection={this.setSection}
					onContinue={this.nextSection}
					dispatch={this.props.dispatch}
					isAccountBilling={true}
					isSubscriptionFlow={true}
					hasClassWallet={!!classWalletCookie}
					changeType={changeType}
				/>
			);

			let mainDiv;

			if (step === "confirm") {
				mainDiv = content;
			} else {
				let topError = null;

				const blockedShipping = OpsParentSubChange.needsShippingToBlockedAddress(
					account
				);
				if (blockedShipping) {
					topError = (
						<div className={styles.topError}>
							{CopyTable.getShippingNotice(styles, true)}
						</div>
					);
				} else if (this.state.topErrorText) {
					topError = (
						<div className={styles.topError}>{this.state.topErrorText}</div>
					);
				}

				const renderedSteps = this.renderSteps();

				mainDiv = (
					<div className={styles.main}>
						<div className={styles.title}>
							{this.getSubscribeTitle(studentName)}
						</div>
						<div className={styles.mainContent}>
							{renderedSteps}
							{topError}
							{content}
						</div>
						<PortalDestination
							className={styles.modal}
							name={PORTAL_CONTAINERS.CHECKOUT}
						/>
					</div>
				);
			}
			return mainDiv;
		},

		render: function() {
			const {account} = this.props;
			const content = (
				<LoadGuard
					identifier={"parentAccountSubs"}
					status={account}
					requestLoad={this.loadParentAccount}
					loadingView={"logo"}
					errorView={"refreshOffice"}
					renderLoaded={this.renderLoaded}
				/>
			);

			const initialLoadingDiv = (
				<div className={styles.mainLoading}>
					<div className={styles.loadingContainer}>
						<LoadingCircle />
					</div>
				</div>
			);
			return (
				<InitRenderSwitch forFirstRender={initialLoadingDiv}>
					{content}
				</InitRenderSwitch>
			);
		},
	})
);
